/**
 * 权限指令
 * 用法: v-hasPermi="'system:user:add'" 或 v-hasPermi="['system:user:add', 'system:user:edit']"
 */
import { useUserStore } from '@/stores/user'
import { expandPermissionAliases } from '@/utils/auth'

/**
 * 用户是否拥有任一所需权限（含动作别名 / 大小写兼容）
 * @param {string[]} userPerms
 * @param {string[]} required
 */
function matchAny(userPerms, required) {
  if (!userPerms || !required?.length) return false
  if (userPerms.includes('*:*:*')) return true
  const lowerUser = userPerms.map((p) => (p || '').toLowerCase())
  return required.some((flag) => {
    const needed = expandPermissionAliases(flag)
    return needed.some((n) => userPerms.includes(n) || lowerUser.includes(n.toLowerCase()))
  })
}

/**
 * 权限检查函数（用于 v-if 场景，如 el-dropdown-item 等组件上不能用指令时）
 * 用法: v-if="checkPermi(['system:user:add'])"
 * @param {string|string[]} value
 */
export function checkPermi(value) {
  const userStore = useUserStore()
  const permissionFlag = Array.isArray(value) ? value : [value]
  return matchAny(userStore.permissions, permissionFlag)
}

export default {
  mounted(el, binding) {
    const { value } = binding
    const userStore = useUserStore()

    if (value && value instanceof Array && value.length > 0) {
      if (!matchAny(userStore.permissions, value)) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else if (value && typeof value === 'string') {
      if (!matchAny(userStore.permissions, [value])) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error('请设置操作权限标签值')
    }
  }
}
